import { Dialog } from "@mui/material";
import { strLang } from "../functions/strLang";
import { iconComp } from "../data/main";
import StdButton from "./StdButton";
import StdInput from "./StdInput";
import { colorsList } from "../data/colorsList";
import { eventsImages } from "../data/eventsData";

export default function GenericModal({
  open = null,
  data = {},
  close = null,
  children,
}) {
  const {
    type,
    title = false,
    intro = "",
    label = "",
    eventId = false,
    btnColumn = false,
    inputList = [],
    table = null,
    style = {},
    tableStyle = {},
    tdStyle = {},
    blocked = false,
  } = data;
  let { buttons = [] } = data;
  if (type && !["loading"].includes(type) && buttons.length === 0) {
    buttons = [{ label: strLang("close"), func: close }];
  }

  const writeIcon = () => {
    try {
      if (typeof type === "string") {
        let Comp = iconComp[type]?.Comp;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom:
                label || children || inputList.length > 0 || buttons.length > 0
                  ? 10
                  : 0,
            }}
          >
            {type === "event" ? (
              <img
                className="prevent-select"
                src={eventsImages["v" + eventId].svg}
                alt={"eventImg"}
                style={{ width: 60 }}
              />
            ) : (
              <Comp
                style={{
                  color: iconComp[type].color,
                  fontSize: 60,
                }}
              />
            )}
          </div>
        );
      }
    } catch (error) {
      console.log("writeIcon", error);
    }
  };

  const writeText = (info, main, align = "center") =>
    typeof info === "string" &&
    info.length > 0 && (
      <div
        style={{
          textAlign: align,
          fontSize: 20,
          maxWidth: 300,
          fontWeight: main ? "bold" : "normal",
          marginBottom: 10,
          color: main ? colorsList.blue : colorsList.black,
          whiteSpace: "pre-line",
        }}
      >
        {info}
      </div>
    );

  const writeCell = (o) =>
    typeof o === "object" && o.src ? (
      <img
        className="prevent-select"
        src={o.src}
        alt={"svg"}
        style={{ width: 30 }}
      />
    ) : (
      o
    );

  const writeTable = () => {
    return (
      Array.isArray(table) && (
        <div style={{ padding: 5 }}>
          <div
            style={{
              maxHeight: 400,
              overflow: "auto",
              borderRadius: 10,
              border: `solid 2px ${colorsList.darkGrey}`,
              ...tableStyle,
            }}
          >
            <table style={{ width: "100%" }} cellSpacing={0}>
              <tbody>
                {table.map((e, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: e.bgColor ?? colorsList.white,
                      cursor: !!e.onClick ? "pointer" : "default",
                    }}
                    onClick={e.onClick}
                  >
                    {e.data.map(
                      (o, idx) =>
                        o && (
                          <td
                            key={idx}
                            style={{
                              padding: 5,
                              ...tdStyle,
                            }}
                          >
                            {writeCell(o)}
                          </td>
                        )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )
    );
  };

  return (
    !!open && (
      <Dialog
        open={!!open}
        onClose={open !== "loading" && !blocked ? close : null}
        slotProps={{
          backdrop: {
            sx: {
              // backgroundColor: "transparent",
            },
          },
        }}
      >
        <div style={{ padding: 20, ...style }}>
          {writeIcon()}
          {writeText(title, true)}
          {writeText(intro, false, "left")}
          {writeText(label)}
          {children}
          {inputList.length > 0 && (
            <div style={{ justifyItems: "center" }}>
              {inputList.map((e, index) => {
                if (e) {
                  const { ref, inputStyle = {}, ...input } = e;
                  return (
                    <div key={index} style={{ width: "100%", ...inputStyle }}>
                      <StdInput refId={input.ref} {...input} />
                    </div>
                  );
                }
                return null;
              })}
            </div>
          )}
          {writeTable()}
          {buttons.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: btnColumn ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: 10,
                gap: 5,
              }}
            >
              {buttons.map(
                (e, index) =>
                  e && (
                    <StdButton
                      key={index}
                      onClick={e.func}
                      label={e.label}
                      color={e.color}
                      width={e.width ?? 70}
                    />
                  )
              )}
            </div>
          )}
        </div>
      </Dialog>
    )
  );
}
